import styled from 'styled-components';
import { margin } from 'styled-system';

import { Container, FontWeight, NakedIcon } from 'theme';
import { Colors } from 'theme/colors';

export const CardIcon = styled(NakedIcon)`
  height: 48px;
  position: absolute;
`;

export const CardNext = styled(Container)`
  height: 32px;
  width: 32px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Card = styled(Container)`
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.16);
  border-radius: 24px;
  margin: 0;
  cursor: pointer;

  & ${CardNext} {
    background-color: ${Colors.whiteSmoke};

    * {
      color: ${Colors.black};
    }
  }

  & ~ & {
    ${margin}
  }

  &:hover {
    box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.16);

    & ${CardNext} {
      background-color: ${Colors.green};

      * {
        color: ${Colors.white};
      }
    }
  }

  &:active:hover {
    box-shadow: unset;
    border: 1px solid ${Colors.green};
  }
`;

export const CardText = styled(Container)`
  font-size: 20px;
  font-weight: ${FontWeight.Bold};
  line-height: 1.2;
  color: ${Colors.black};
`;
